<template>
    <div>
        <a-button type="primary" icon="plus" @click="addBillingRule" class="add-button">添加计费规则</a-button>
        <div class="billing-rule-form">
            <a-form-model ref="billingRuleForm" :model="billingForm" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                <div v-for="(rule, index) in billingForm.billingRule" :key="index">
                    <div class="rule-container">
                        <div class="rule-header">
                            <h4>规则 {{ index + 1 }}</h4>
                            <a-button v-if="index > 0" danger icon="delete" @click="removeBillingRule(index)"></a-button>
                        </div>
                        <a-row :gutter="2" >
                            <a-col :span="8">
                                <a-form-model-item label="开始时间" :prop="`billingRule[${index}].startTime`" :rules="[
                                    { required: true, message: '请选择开始时间', trigger: 'change' }
                                ]">
                                    <a-time-picker :disabled="index>0" v-model="rule.startTime" :default-open-value="moment('00:00:00', 'HH:mm:ss')" format="HH:mm:ss" value-format="HH:mm:ss" />
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item label="结束时间" :prop="`billingRule[${index}].endTime`" :rules="[
                                    { required: true, message: '请选择结束时间', trigger: 'change' }
                                ]">
                                    <a-time-picker v-model="rule.endTime" :default-open-value="moment('09:00:00', 'HH:mm:ss')" format="HH:mm:ss" value-format="HH:mm:ss"  @change="handleEndTimeChange(index)"/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item label="价格" :prop="`billingRule[${index}].price`" :rules="[
                                    { required: true, message: '请输入价格', trigger: 'blur' },
                                    { type: 'number', min: 0, message: '价格不能为负数', trigger: 'blur' }
                                ]">
                                    <a-input-number v-model="rule.price" :min="0" class="full-width-input" />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                    </div>
                </div>
                <div v-if="billingForm.billingRule.length === 0" class="empty-state">
                    暂无计费规则，请点击上方按钮添加
                </div>
            </a-form-model>
        </div>
    </div>

</template>
<script>
import moment from 'moment'
export default {
    name: 'BillingRuleFrom',
    props:{
        priceId: {type: Number, default: 0}
    },
    data() {
        return {
            moment,
            billingRuleVisible: true,
            billingRuleConfirmLoading: false,
            billingForm: {
                billingRule: [
                    {
                        startTime: '',
                        endTime: '',
                        price: 0,
                    }
                ]
            }
        }
    },
    created() {
        this.initBillingRule()
    },
    methods: {
        // 添加计费规则
        addBillingRule() {
            this.$refs.billingRuleForm.validate(valid => {
                if (valid) {
                    // 添加验证
                    const flag = this.billingRuleVisibleChange()
                    if(!flag){
                        return false;
                    } 
                    const rules = this.billingForm.billingRule;
                    let newStartTime = '';
                    if (rules.length > 0) {
                        const lastEndTime = rules[rules.length - 1].endTime;
                        if (lastEndTime) {
                            const today = new Date().toISOString().split('T')[0];
                            const endDateTime = new Date(`${today}T${lastEndTime}`);
                            
                            endDateTime.setSeconds(endDateTime.getSeconds() + 1);
                            
                            newStartTime = endDateTime.toTimeString().split(' ')[0];
                        }
                    }

                    this.billingForm.billingRule.push({
                        startTime: newStartTime,
                        endTime: '',
                        price: 0
                    });
                } else {
                    return false;
                }
            });
        },
        billingRuleVisibleChange(){
            for(let i=0; i<this.billingForm.billingRule.length; i++){
                if(this.billingForm.billingRule[i].startTime >= this.billingForm.billingRule[i].endTime){
                    this.$message.warning('规则' + (i+1) + '：结束时间不能早于开始时间')
                    return false;
                }
            }
            return true;
        },
        // 移除计费规则
        removeBillingRule(index) {
            if (index < this.billingForm.billingRule.length-1) {
                const startTime = this.billingForm.billingRule[index].startTime
                this.billingForm.billingRule[index + 1].startTime = startTime
            }
            this.billingForm.billingRule.splice(index, 1)

        },
        handleEndTimeChange(index) {
            this.billingForm.billingRule.splice(index + 1)
        },
        async initBillingRule(){
            let billingRule = [{
                startTime: '',
                endTime: '',
                price: 0
            }]
            if(this.priceId > 0){
                this.billingForm.priceConfigId = this.priceId
                try {
                    const { data: res } = await this.$http.post(this.navigation.apiGetBillingRuleByPriceId, {
                        priceId: this.priceId
                    });
                    if (res.code == 200 && res.data.length > 0) { 
                        this.billingForm.billingRule = res.data.map(item => ({
                            ...item,
                            price: item.price/100
                        }));
                    } else {
                        this.$message.error(res.msg);
                        this.billingForm.billingRule = billingRule;
                    }
                } catch (error) {
                    this.billingForm.billingRule = billingRule;
                }
            }else{
                this.billingForm.billingRule = billingRule;
            }
            this.billingRuleVisible = true
        },
        billingRuleHandleOk(){
            this.$refs.billingRuleForm.validate(valid => {
                if (valid) {
                    const flag = this.billingRuleVisibleChange()
                    if(!flag){
                        return false;
                    }
                    this.apiPriceEditBillingRule();
                } else {
                    return false;
                }
            });
        },
        async apiPriceEditBillingRule() {
            this.billingRuleConfirmLoading = true
            let billingRule = this.billingForm.billingRule.map(item => ({
                startTime: item.startTime,
                endTime: item.endTime,
                price: parseInt(item.price*100)
            }))
            const { data: res } = await this.$http.post(this.navigation.apiPriceEditBillingRule, {
                priceConfigId:this.billingForm.priceConfigId, billingTemplateJson:JSON.stringify(billingRule),
            });
            if (res.code == 200) {
                this.$message.success(res.msg)
                this.$emit('close')
            } else {
                this.$message.error(res.msg)
                this.$emit('close')
            }
        },

    }
}

</script>

<style scoped>
.add-button {
    margin-bottom: 10px;
}

.rule-container {
    border: 1px solid #e8e8e8;
    padding: 5px 10px;
    margin-bottom: 5px;
    border-radius: 4px;
}

.rule-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.full-width-input {
    width: 100%;
}

.empty-state {
    text-align: center;
    padding: 32px;
    color: #999;
}
.billing-rule-form{
    min-height: 400px;
    max-height: 500px;
    overflow-y: auto;
    /* padding: 10px; */
    /* border: 1px solid #e8e8e8; */
    /* border-radius: 4px; */
}
</style>